import { Button, Popover } from 'antd';
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Heart, LogoFull, User } from '../../assets/icons';
import { Discover } from '../../assets/icons/Discover';
import { Ipo } from '../../assets/icons/IPO';
import { Loop } from '../../assets/icons/Loop';
import ShareLike from '../../components/ShareLike/ShareLike';
import useSecondaryMarketEligibility from '../../Hooks/useSecondaryMarketEligibility';
import MyAccountPopOver from '../MyAccountPopOver/MyAccountPopOver';
import './AccountNav.scss';
import {handleLoginButtonNavigation,handleSignupButtonNavigation} from '../../utils/handleLoginSignupRedirection'

const AccountNav = (props) => {
  const [openPopOver, setOpenPopOver] = useState(false);
  const userProfileData = useSelector((state) => state.userData.userData);
  const [isAnimate, setIsAnimate] = useState(false);
  const { addedToFavorites } = useSelector((state) => state?.favorites);
  const prevValue = useRef(addedToFavorites);
  const [logoutModal, setLogoutModal] = useState(false);
  const [isInvestVisible, setIsInvestVisible] = useState(false);
  const { isEntityRestricted } = useSecondaryMarketEligibility();
  const isLoggedIn = !!localStorage.getItem('access_token');

  const content = (
    <div className='invest-drop'>
      <ul>
        <li className='inv-drop-list'>
          <Link to='/' onClick={() => setIsInvestVisible(false)}>
            <span className='inv-drop-list__icon'>
              <Discover verticalAlign='middle' />
            </span>
            <div className='inv-drop-list__list'>
              <p>Discover</p>
              <span>Browse all of our exclusive properties</span>
            </div>
          </Link>
        </li>
        <li className='inv-drop-list'>
          <Link to='/marketplace/initial' onClick={() => setIsInvestVisible(false)}>
            <span className='inv-drop-list__icon'>
              <Ipo verticalAlign='middle' />
            </span>
            <div className='inv-drop-list__list'>
              <p>Initial Offerings</p>
              <span>Get in early with our hand-picked investments</span>
            </div>
          </Link>
        </li>
        {isLoggedIn && !isEntityRestricted && (
          <li className='inv-drop-list'>
            <Link to='/marketplace/secondary' onClick={() => setIsInvestVisible(false)}>
              <span className='inv-drop-list__icon'>
                <Loop verticalAlign='middle' />
              </span>
              <div className='inv-drop-list__list'>
                <p>Market</p>
                <span>Purchase shares of available residential properties.</span>
              </div>
            </Link>
          </li>
        )}
      </ul>
    </div>
  );

  useEffect(() => {
    let timer;
    if (addedToFavorites && addedToFavorites !== prevValue.current) {
      setIsAnimate(true);
      setTimeout(() => {
        timer = setIsAnimate(false);
      }, 750);
    }
    return () => {
      clearTimeout(timer);
    };
  }, [addedToFavorites]);

  return (
    <nav className='accountnav' id='nav'>
      <div className='accountnav__logo'>
        {Object.keys(userProfileData).length > 0 ? (
          <Link to='/'>
            <LogoFull color='#1a1519' verticalAlign='middle' />
          </Link>
        ) : (
          <a href='https://www.realbricks.com' target='_blank' rel='noreferrer'>
            <LogoFull color='#1a1519' verticalAlign='middle' />
          </a>
        )}
      </div>
      <ul className='accountnav__list'>
        <Popover
          placement='bottomLeft'
          getPopupContainer={() => document.getElementById('nav')}
          content={content}
          trigger='click'
          className='invest-dropdown'
          overlayClassName='invest-dropdown'
          open={isInvestVisible}
          onOpenChange={(visible) => setIsInvestVisible(visible)}
        >
          <li className={`accountnav__list__item cursor-pointer ${isInvestVisible ? 'active__item' : ''}`}>
            <Link to="/" onClick={(e) => e.preventDefault()}>Invest</Link>
          </li>
        </Popover>

        {!!Object.keys(userProfileData)?.length && (
          <li className='accountnav__list__item'>
            <Link to='/portfolio'>Portfolio</Link>
          </li>
        )}
        <li className='accountnav__list__item'>
          <a href='https://www.realbricks.com/learn' target='_self' rel='noreferrer'>
            Learn
          </a>
        </li>
      </ul>

      {!!Object.keys(userProfileData)?.length && localStorage.getItem('access_token') ? (
        <ul className='accountnav__actions'>
          <ShareLike showFavourite={false} isHeader={true} />
          <li className='accountnav__actions__item'>
            <Link to='/marketplace/favorites'>
              <div className={`heart ${isAnimate ? 'animate' : ''}`}>
                <Heart verticalAlign={`middle`} color='#1a1519' />
                <span className='added'>+1</span>
              </div>
            </Link>
          </li>
          <Popover
            onMouseEnter={() => !logoutModal && setOpenPopOver(true)}
            open={!logoutModal && openPopOver}
            getPopupContainer={() => document.getElementById('nav')}
            content={
              <MyAccountPopOver
                mouseEnter={() => !logoutModal && setOpenPopOver(true)}
                mouseLeave={() => setOpenPopOver(false)}
                logoutModal={logoutModal}
                setLogoutModal={setLogoutModal}
              />
            }
            placement='bottomRight'
          >
            <li className='accountnav__actions__item'>
              <span>
                <User verticalAlign='middle' marginRight='5px' /> <span className='fw-600 text-copper'> Hi, {userProfileData?.firstName}</span>
              </span>
            </li>
          </Popover>
        </ul>
      ) : (
        <ul className='accountnav__actions'>
          <Button type='primary' className='w-100' href='/login' onClick={handleLoginButtonNavigation}>
            Log in
          </Button>
          <Button type='primary' className='w-100' href='/sign-upAuth' onClick={handleSignupButtonNavigation}>
            Sign up
          </Button>
        </ul>
      )}
    </nav>
  );
};

AccountNav.propTypes = {
  navigateToHome: PropTypes.func,
};
export default AccountNav;
